import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export interface VehicleImages {
  imageUrlFront: string;
  imageUrlBack: string;
  imageUrlLeft: string;
  imageUrlRight: string;
}

export interface VehicleDimensions {
  weight: number;
  length: number;
  width: number;
}

export interface Crlv {
  crlvId: string;
  documentNumber: string;
  dueDate: string;
  imageUrlFront?: string;
  imageUrlBack?: string;
  isDigital: boolean;
}

export interface Vehicle {
  vehicleId: string;
  model: string;
  year: number;
  plate: string;
  payloadCapacity: number;
  vehicleType: string;
  images: VehicleImages;
  dimensions: VehicleDimensions;
  crlv: Crlv;
  createdAt: string;
  updatedAt: string;
}

export interface GetPrivateVehiclesResponse {
  page: number;
  rows: Vehicle[];
  totalRecords: number;
  startDate?: string;
  endDate?: string;
}

export default function useGetPrivateVehicles() {
  const [loading, setLoading] = useState(false);

  async function execute(params: {
    page: number;
    rowsPerPage?: number;
    searchFilter?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<GetPrivateVehiclesResponse | undefined> {
    try {
      setLoading(true);

      const distributorData = localStorage.getItem('distributor');
      let token = '';
      if (distributorData) {
        try {
          const parsed = JSON.parse(distributorData);
          token = parsed.token || '';
        } catch(e: any) {
          console.log('Erro:', e?.message)
        }
      }

      const headers: Record<string, string> = {};
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await api.get<GetPrivateVehiclesResponse>(
        'v1/api/vehicles',
        {
          params: {
            rowsPerPage: params.rowsPerPage || 10,
            page: params.page,
            searchFilter: params.searchFilter,
            status: params.status !== 'Todos' ? params.status : undefined,
            startDate: params.startDate,
            endDate: params.endDate,
          },
          headers,
        },
      );

      return response.data;
    } catch (error) {
      if (
        (error as any).response &&
        (error as any).response.data &&
        Array.isArray((error as any).response.data.message)
      ) {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      } else {
        toast.error(ToastMessages.general.error.genericError);
      }
      return undefined;
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
